import MultiSelect from './MultiSelect';
import { states } from './StatePicker';

/**
 * `label` opts into the design-system field skin (caption inside the control),
 * for the v3 filter cards. Left off, the legacy look is unchanged — the profile
 * map still renders it with its own caption above.
 */
export const MultiStatePicker = ({ value, onChange, label, style = {}, optionsStyle = {} }) => {
  const options = states
    .sort((a, b) => a.abbreviation.localeCompare(b.abbreviation))
    .map((state) => ({
      label: state.abbreviation,
      value: state.abbreviation,
    }));

  return (
    <MultiSelect
      label={label}
      className={label ? undefined : 'custom-select custom-select-lg'}
      style={label ? style : { position: 'relative', ...style }}
      optionsStyle={{ width: 250, ...optionsStyle }}
      value={value ? value?.split(',') : options.map((el) => el?.value)}
      options={options}
      onChange={(values) =>
        onChange(values.length === options.length ? undefined : values.join(','))
      }
      placeholder="All"
      showAllButton
      autoApply={false}
    />
  );
};
